module.exports = __webpack_public_path__ + "img/utilityvalvac_stopped.4ab99830.svg";